import { initialStateInfoFiscal } from "../initialStates/infoFiscal";

export const cloneTaxData = (value) =>
  typeof value === "string" ? JSON.parse(value) : JSON.parse(JSON.stringify(value));

export const createManualTax = () => {
  const taxes = cloneTaxData(initialStateInfoFiscal.imposto_manual);
  taxes.icms.informar_credito_presumido = false;
  taxes.issqn.informar_issqn = false;
  return taxes;
};

export const completeManualTaxDefaults = (value) => {
  const defaults = createManualTax();
  if (!value) return defaults;

  const fillMissing = (template, current) => {
    if (template === null || typeof template !== "object") {
      if (current === undefined) return template;
      if ((current === null || current === "") && template !== null) return template;
      return current;
    }

    if (!current || typeof current !== "object" || Array.isArray(current)) {
      return cloneTaxData(template);
    }

    const result = { ...current };
    Object.keys(template).forEach((key) => {
      result[key] = fillMissing(template[key], current[key]);
    });
    return result;
  };

  return fillMissing(defaults, cloneTaxData(value));
};

export const applyItemTaxFromRef = (item, ref, refs) => {
  const selected = (refs || []).find((tax) => tax.ref === ref);
  if (ref && !selected) return false;
  const taxes = selected?.flags?.isManual
    ? completeManualTaxDefaults(selected.imposto_manual)
    : createManualTax();
  taxes.icms.informar_credito_presumido = Boolean(selected?.flags?.enableCreditoPresumido);
  taxes.issqn.informar_issqn = Boolean(selected?.flags?.enableIssqn);
  item.imposto_manual = taxes;
  item.usar_imposto_manual = Boolean(selected?.flags?.isManual);
  return true;
};

export const ensureItemTax = (item, refs) => {
  item.classe_imposto = item.classe_imposto || item.refFiscal || "";
  if (item.imposto_manual) {
    item.imposto_manual = completeManualTaxDefaults(item.imposto_manual);
    item.usar_imposto_manual = Boolean(item.usar_imposto_manual);
  } else {
    item.usar_imposto_manual = false;
    if (!applyItemTaxFromRef(item, item.classe_imposto, refs)) {
      item.imposto_manual = createManualTax();
    }
  }
  return item;
};
